import { RuleSetOverview } from '../EntityPages';

export const RuleSetOverviewTab = () => {
  return <RuleSetOverview />;
};
